import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import Layout from './src/components/Layout/Layout';
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return <Layout>{element}</Layout>;
};
export const onInitialClientRender = () => {
  if (typeof document === 'object') {
    document.getElementById('___loader')!.style.display = 'none';
  }
};
